<template>
    <div :class="['page edit-picture',{ off: !pageOn }]">
        <VHeader type="back" @back="back" />
        <div class="page-content" style="position: relative;" :style="{ backgroundColor: backgroundColor, color: fontColor }">
            <div class="img-container" @mousedown="startmove" @mousemove="move" @touchstart="startmove" @touchmove="move" @mouseup="moving = false">
                <img class="in-img" :src="editImageURL" @load="positionImage($event)" />
                <canvas class="out-img" width="100" height="100"></canvas>
                <div class="edit-window" :style="{ top: top+'px', left: left+'px', width: width+'px', height: height+'px' }">
                    <div class="dashed-v"></div>
                    <div class="dashed-h"></div>
                    <div class="center"></div>
                    <div class="points">
                        <div class="n"></div>
                        <div class="e"></div>
                        <div class="s"></div>
                        <div class="w"></div>
                        <div class="ne"></div>
                        <div class="nw"></div>
                        <div class="se"></div>
                        <div class="sw"></div>
                    </div>
                    <div class="center"></div>
                    <div class="regions">
                        <div class="n-e"></div>
                        <div class="n-w"></div>
                        <div class="s-e"></div>
                        <div class="s-w"></div>
                    </div>
                </div>
            </div>
            <p class="btn" @click="saveImage" style="position:absolute;bottom:100px;width:calc(100% - 80px)">save picture</p>
        </div>
    </div>     
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapMutations } from 'vuex'
//import EXIF from 'exif-js';

import exifr from 'exifr';

export default {
    name: 'edit-picture',
    components: {
        VHeader,
    },
    computed: {
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor }, 
        infoFontColor () { return this.$store.state.infoFontColor },
        editImageURL () { return this.$store.state.editImageURL },
        client_id () { return this.$store.state.client_id },
        customer_id () { return this.$store.state.auth._id },
        customerId () { return this.$store.state.auth.id },
    },
    data () {
        return {
            top: 100,
            left: 100,
            width: 200,
            height: 200,
            startX: 0,
            startY: 0,
            moving: false,
            region: '',
            img: false,
            inCanvas: false,
            outCanvas: false,
            inCtx: false,
            outCtx: false,
            ratio: false,
            outSrc: '',
            EXIFData: null,
            imgLeft: 0
        }
    },
    mixins: [ pageOn ],
    mounted () {
        this.initCanvas();
    },
    methods: {
        positionImage ( e ) {
            var width = parseInt(getComputedStyle(this.$el).width);
            var imgWidth = parseInt(getComputedStyle(e.target).width);
            this.imgLeft = (( width - imgWidth ) / 2 );
            this.imgScale = width / imgWidth;
            e.target.style.marginLeft = (( width - imgWidth ) / 2 ) + 'px';

            var img  = this.img = document.createElement('img');
                img.onload = () => {
                    var screenWidth = this.$el.querySelector('img').width;
                    var screenHeight = parseInt(getComputedStyle(this.$el.querySelector('.img-container')).height);  
                    this.getImgData(img,(EXIFData) => { this.EXIFData = EXIFData; });
                    this.top = ( screenHeight / 2 ) - ( this.height / 2 );
                    this.left = ( screenWidth / 2 ) - this.width / 2;
                    this.ratio = this.$el.querySelector('img').width / img.width;
                    this.outCanvas = this.$el.querySelector('canvas.out-img');
                    this.outCanvas.width = 100;
                    this.outCanvas.height = 100;
                    this.outCtx = this.outCanvas.getContext('2d');
                    setTimeout(() => {
                        this.updateCanvas();    
                    },50);
                        
                }
                img.src = this.editImageURL;
            
        },
        initCanvas () {

        },
        getImgData ( img, cB ) {

            exifr.parse(img,true).then(data => {
                //console.log('exifr.parse data',data);
                cB({ orientation: data.Orientation || 'Landscape', lat: data.GPSLatitude || 0, lng: data.GPSLongitude });
            })

            exifr.orientation(img,true).then(data => {
                console.log('orentation data',data);

            });

            exifr.gps(img).then(data => {
                console.log('gps data',data);
            })

            return;

            EXIF.getData(img,function(resp) {
                var orientation = EXIF.getTag(img,'Orientation');
                var Lat = EXIF.getTag(this,'GPSLatitude');
                var Lng = EXIF.getTag(this,'GPSLongitude');
                cB({ orientation, lat: toDecimal(Lat), lng: toDecimal(Lng) });
            })

            function toDecimal(number) { return number[0].numerator + number[1].numerator / (60 * number[1].denominator) + number[2].numerator / (3600 * number[2].denominator); };
        },
        updateCanvas () {
            var { left, top, width, height, ratio, EXIFData, marginLeft } = this;
            switch ( EXIFData.orientation ) {
                default:
                    //console.log('EXIFData.orentation',EXIFData.orientation)
            }
            this.outCtx.fillStyle = 'white';
            this.outCtx.fillRect(0,0,width / ratio,height/ratio);
            
            this.outCtx.drawImage(this.img, left / ratio, top / ratio, width / ratio,height / ratio,0,0,100,100)
        },
        saveImage () {
            console.log('saveIamge');
            var base64 = this.$el.querySelector('canvas').toDataURL();
            this.postMinify(base64);
            this.setValue({ k: 'avatar', v: base64 });
            this.popPage('edit-avatar');
            this.back();
        },
        postMinify ( dataURL ) {
            fetch(dataURL)
            .then(res => res.blob())
                .then(blob => {
                var x = new XMLHttpRequest();
                    x.onload = () => { 
                        if ( x.readyState == 4 && x.status == 200 ) {
                            var resp = JSON.parse(x.responseText);
                            this.setValue({ k: 'avatar', v: resp.url });
                            WebSoc.SEND({ t: 'saveAvatar', data: { client_id: this.client_id, customer_id: this.customer_id, customerId: this.customerId, avatar: resp.url }},() => {

                            });
                        }
                    };
                    x.open('POST','https://api.survey-vip.com/minify?key=01c3cb5a33f0b47e8d3e9e4521f4ba4a');
                    x.send(blob);
            })
        },
        startmove (e) {
            if ( e.touches ) { e = e.touches[0] }
            this.moving = true;
            var startX = this.startX = e.clientX;
            var startY = this.startY = e.clientY;
            var region = this.region = e.target.className;
            //var { top, left } = this;
            //console.log({ startX, startY, region, top, left });
            
        },
        move ( e ) {
            
            if ( !this.moving ) return;
            if ( e.touches ) { e = e.touches[0] }
            var ratio = this.width / this.height;
            //console.log('ratio',ratio,this.ratio);
            var changeX = ( this.startX - e.clientX )
            var changeY = ( this.startY - e.clientY )
            
            switch ( this.region ) {
                case 'n-e':
                    this.top -= changeY;
                    this.width -= changeX;
                    this.height += changeY;
                break;
                case 'n-w':
                    this.top -= changeY;
                    this.left -= changeX;
                    this.width += changeX;
                    this.height += changeY;
                break;
                case 's-e':
                    this.width -= changeX;
                    this.height -= changeY;
                break;
                case 's-w':
                    this.left += changeY;
                    this.width += changeX;
                    this.height -= changeY;
                break;
                default:
                    this.top -= changeY;
                    this.left -= changeX;
            }
            this.startY = e.clientY;
            this.startX = e.clientX;
            this.updateCanvas();
        },        
        back () {
            this.pageOn = false;
        },
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
    }
}

</script>

<style lang="scss" scoped>
.edit-picture {
    img.in-img { max-width: 100%; max-height: 500px; }
    canvas.out-img {
        border: 2px solid white;
        position: absolute;
        top: -10px;
        right: 5px;
        border-radius: 50%;
        width: 100px;
        height: 100px;
        z-index: 100;
        padding: 0px;
    }
    .edit-window {
        position: absolute;
        background-color: rgba(200,200,200,0.4);
        border: 1px solid #39f;
        .dashed-v {
            &:before,&:after {
                content: '';
                height: 100%;
                position: absolute;
                width: 2px;
                border: 1px dashed rgba(250,250,250,0.9);
                left: 30%;
                border-top-width: 0px;
                border-bottom-width: 0px;
            }
            &:after {
                left: 70%;
            }
        }
        .dashed-h {
            &:before,&:after {
                content: '';
                height: 2px;
                position: absolute;
                width: 100%;
                border: 1px dashed rgba(250,250,250,0.9);
                top: 30%;
                border-left-width: 0px;
                border-right-width: 0px;                
            }
            &:after {
                top: 70%;
            }
        }
        .points {
            position: absolute;
            width: 100%;
            height: 100%;
            > * {
                width: 6px;
                height: 6px;
                background-color: #39f;
                position: absolute;
            }
            .ne { top: -3px; left: -3px; }
            .nw { top: -3px; right: -3px; }
            .se { bottom: -3px; right: -3px; }
            .sw { bottom: -3px; left: -3px; }
            .n { top: -3px; right: 50%; }
            .e { top: 50%; right: -3px; }
            .s { bottom: -4px; right: 50%; }
            .w { top: 50%; left: -3px; }
        }
        .regions {
            width: 100%;
            height: 100%;
            position: absolute;
            > * {
                width: 30%;
                height: 30%;
                position: absolute;
            }
            .n-w { top: -15%; left: -15%; }
            .n-e { top: -15%; right: -15%;  }
            .s-e { bottom: -15%; right: -15%; }
            .s-w { bottom: -15%; left: -15%; }
        }
    }
}
</style>